import { render, staticRenderFns } from "./CardProducts.vue?vue&type=template&id=aacfe34a&scoped=true&"
import script from "./CardProducts.vue?vue&type=script&lang=js&"
export * from "./CardProducts.vue?vue&type=script&lang=js&"
import style0 from "./CardProducts.vue?vue&type=style&index=0&id=aacfe34a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aacfe34a",
  null
  
)

export default component.exports